import { render, staticRenderFns } from "./VpnCallMenuButton.vue?vue&type=template&id=34cce362&scoped=true&"
import script from "./VpnCallMenuButton.vue?vue&type=script&lang=js&"
export * from "./VpnCallMenuButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34cce362",
  null
  
)

export default component.exports